import axios from 'axios';
import { EMPLOYEE_DETAILS } from 'RestAPIs/endpoints';

export type EmployeeDetailsValues = {
  employeeId: number;
};

export type EmployeeDetailsResponse = {
  adrResPostalcode: string;
};

export const getEmployeeDetails = ({ employeeId }: EmployeeDetailsValues) =>
  axios.get<EmployeeDetailsResponse>(EMPLOYEE_DETAILS, {
    pathParams: {
      employeeId
    }
  });
